module.exports = "//cdn.mxpnl.com/static/asset-cache/b4e06b62eb398a4623ded7072bdda2df/iron/common/assets/images/customer-logos/bmw-logo.png";